import { render, staticRenderFns } from "./ProductAttributesDialog.vue?vue&type=template&id=74a61659"
import script from "./ProductAttributesDialog.vue?vue&type=script&lang=js"
export * from "./ProductAttributesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports